import { render, staticRenderFns } from "./myGoalsYouHaveSaved.vue?vue&type=template&id=7725f84d"
import script from "./myGoalsYouHaveSaved.js?vue&type=script&lang=js&external"
export * from "./myGoalsYouHaveSaved.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports